import {Button, Divider, Heading, Stack, Text, useTheme, VStack} from '@chakra-ui/react'
import {Dayjs} from 'dayjs'
import Link from 'next/link'
import {ReactNode} from 'react'
import {getProfileTabURL, USER_PROFILE_TABS} from '../../constants/routes'
import InfoWIcon from './InfoWIcon'
import useTranslation from 'next-translate/useTranslation'
import {useRouter} from 'next/router'

interface Props {
  onModify?: () => void
  onCancel?: () => void
  free?: boolean
  remainingBudget: number
  monthlyBudget: number
  renewDate: Dayjs
  plan: string
  icon: ReactNode
  price: number
  first14DayBudget?: number
}

const PriceSubscription = ({
  icon,
  renewDate,
  plan,
  price,
  free,
  remainingBudget,
  monthlyBudget,
  first14DayBudget,
}: Props) => {
  const theme = useTheme()
  const router = useRouter()

  const {t} = useTranslation('subscription')
  const date = renewDate.locale(router.locale ?? 'fr').format('DD MMMM')

  return (
    <VStack
      spacing={5}
      w='full'
      p={8}
      background={theme.colors.layers.appLevel2}
      borderRadius={theme.radii.medium}
      align='start'>
      <InfoWIcon
        mainText={
          free ? t('pricing_subscription_free') : price.toString() + t('pricing_block_currency')
        }
        customIcon={icon}
        header={plan}
        smallText={free ? undefined : t('pricing_block_month')}
      />
      <Stack
        direction={['column', null, null, 'row']}
        alignItems={['flex-start', null, null, 'flex-end']}>
        <Heading variant='medium' color={theme.colors.text.basic}>
          {remainingBudget}
        </Heading>
        <Text variant='medium' color={theme.colors.text.basic}>
          {t('pricing_subscription_text_pricing', {date: date})}
        </Text>
      </Stack>

      <Divider />
      <VStack w='full' alignItems='flex-start' spacing={4}>
        <Text variant='small' color={theme.colors.text.basic}>
          {free
            ? t('pricing_subscription_description_free', {
                first14daysNbGenerations: first14DayBudget,
                nbGenerations: monthlyBudget,
              })
            : t('pricing_subscription_description_pricing', {
                nbGenerations: monthlyBudget,
              })}
        </Text>
        <Link href={getProfileTabURL(USER_PROFILE_TABS.subscription)} passHref>
          <Button variant='primary' w={['full', null, null, 'auto']}>
            {t('profile:user_details_button')}
          </Button>
        </Link>
      </VStack>
    </VStack>
  )
}

export default PriceSubscription
